module.exports = class MemoryStore {
	constructor(auth = null) {
		this._auth = auth;
	}

	get() {
		return this._auth || null;
	}

	set(auth) {
		this._auth = auth;
	}
};
